export default "__VITE_ASSET__BThaK3bh__"